import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "w-full bg-gray-400 p-2" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "flex gap-4" }
const _hoisted_5 = { class: "flex gap-4" }
const _hoisted_6 = { class: "w-full bg-gray-400 p-2" }
const _hoisted_7 = { class: "text-lg font-semibold" }
const _hoisted_8 = { class: "flex gap-4" }

import {Plus} from "lucide-vue-next";
  import {useRoofStore} from "@/store/roof.store";
  import {ref, watch} from "vue";
  import RoofsTable from "@/components/building/RoofsTable.vue";
  import {Button} from "@/components/ui/button";
  import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form";
  import {Separator} from "@/components/ui/separator";
  import {Input} from "@/components/ui/input";
  import {Textarea} from "@/components/ui/textarea";
  import {useForm} from "vee-validate";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {storeToRefs} from "pinia";
  import TablesService from "@/services/tables/tables.service";
  import {i18n} from "@/utils/i18n";
  import {toast} from "@/utils/utils";
  import useEventsBus from "@/utils/eventBus";
  import ElementsModal from "@/components/building/ElementsModal.vue";
  import ElementsTable from "@/components/building/ElementsTable.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoofsForm',
  props: {
    id: {},
    entity: {}
  },
  setup(__props: any) {

  const props = __props
  const roofStore = useRoofStore();
  const roofForm = ref(false);
  const isElementDialogOpen = ref(false);
  const { bus } = useEventsBus();
  let { roof_list } = storeToRefs(roofStore);
  let { element_list } = storeToRefs(roofStore);

  const roofSchema = toTypedSchema(z.object({
    name: z.string(),
    code: z.string(),
    description: z.string(),
    estimatedLife: z.number(),
    installationYear: z.number(),
    dimensions: z.number(),
    slope: z.number(),
    constructionCost: z.number(),
    interventionCost: z.number(),
  }))
  const addButton = ref(true);

  const setIsElementDialogOpen = (value: boolean) => {
    isElementDialogOpen.value = value;
  };

  const { handleSubmit, setValues } = useForm({
    validationSchema: roofSchema
  })

  watch(() => bus.value.get('delete_'+props.entity), async (value) => {
    await deleteRoof(value);
  })

  async function deleteRoof(id: any) {
    const res = await TablesService.deleteRecord(id, props.entity);
    if (res?.data) {
      toast.success(i18n.global.t('toast.delete_success'));
    }
  }

  async function addElement(element: any) {
    element_list.value = await roofStore.addElementToList(element);
    setIsElementDialogOpen(false);
  }

  async function deleteElement(element: any) {
    element_list.value = await roofStore.removeElementFromList(element);
    toast.success(i18n.global.t('toast.delete_success'));
  }

  async function editRoof(roof: any) {
    addButton.value = false;
    const roofInStore = await roofStore.setRoof(roof);
    element_list.value = roof.coverageElements;
    setValues(roofInStore);
    roofForm.value = true;
  }

  const addRoof = handleSubmit(async (values: any) => {
    let res;
    let roofInStore = await roofStore.getRoof() as any;
    values.building = props.id;
    Object.assign(roofInStore, values);
    roofInStore.coverageElements = element_list.value;
    if (roofInStore.id) {
      res = await TablesService.updateRecord(roofInStore, props.entity);
      if (res?.data) {
        roofStore.clearRoof();
        toast.success(i18n.global.t('toast.edit_success'));
        roofForm.value = false;
      }
    } else {
      res = await TablesService.createRecord(roofInStore, props.entity);
      if (res?.data) {
        roofInStore.id = res.data.id
        await roofStore.addRoofToList(roofInStore);
        roofStore.clearRoof();
        toast.success(i18n.global.t('toast.insert_success'));
        roofForm.value = false;
      }
    }
    addButton.value = true;
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (addButton.value)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {roofForm.value = true; addButton.value = false;}, ["prevent"])),
          type: "button",
          class: "w-full text-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Plus), { class: "mr-2 h-5 w-5" }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_roof')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (roofForm.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(addRoof) && _unref(addRoof)(...args)))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(FormField), { name: "name" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.name')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.name'),
                          type: "text",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(FormField), { name: "code" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.code')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.code'),
                          type: "text",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(FormField), { name: "description" }, {
            default: _withCtx(({ componentField }) => [
              _createVNode(_unref(FormItem), { class: "w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('column.description')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormControl), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Textarea), _mergeProps(componentField, {
                        id: "description",
                        placeholder: _ctx.$t('column.description')
                      }), null, 16, ["placeholder"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(FormMessage))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_unref(Separator), { class: "mt-3" }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('building.generality')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(FormField), { name: "estimatedLife" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.estimated_life')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.estimated_life'),
                          type: "number",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(FormField), { name: "installationYear" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.installation_year')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.installation_year'),
                          type: "number",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(FormField), { name: "dimensions" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.dimensions')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.dimensions'),
                          type: "number",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(FormField), { name: "slope" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.slope')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.slope'),
                          type: "number",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(FormField), { name: "constructionCost" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.construction_cost')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.construction_cost'),
                          type: "number",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }),
            _createVNode(_unref(FormField), { name: "interventionCost" }, {
              default: _withCtx(({ componentField }) => [
                _createVNode(_unref(FormItem), { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(FormLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('column.intervention_cost')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(FormControl), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Input), _mergeProps(componentField, {
                          placeholder: _ctx.$t('column.intervention_cost'),
                          type: "number",
                          "auto-correct": "off"
                        }), null, 16, ["placeholder"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(FormMessage))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(Separator), { class: "my-3" }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('menu.coverage_elements')), 1)
          ]),
          _createVNode(_unref(Button), {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsElementDialogOpen(true)), ["prevent"])),
            type: "button",
            class: "w-full text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Plus), { class: "mr-2 h-5 w-5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_element')), 1)
            ]),
            _: 1
          }),
          _createVNode(ElementsModal, {
            open: isElementDialogOpen.value,
            "set-open": setIsElementDialogOpen,
            onAdd: addElement
          }, null, 8, ["open"]),
          (_unref(element_list).length !== 0)
            ? (_openBlock(), _createBlock(ElementsTable, {
                key: 0,
                elements: _unref(element_list),
                entity: "defects",
                onDelete: deleteElement
              }, null, 8, ["elements"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(Separator), { class: "my-6" }),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Button), {
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => {roofForm.value = false; _unref(roofStore).clearRoof(); addButton.value = true}, ["prevent"])),
              type: "button",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              onClick: _withModifiers(_unref(addRoof), ["prevent"]),
              type: "button",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('table.save')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_unref(roof_list).length !== 0)
      ? (_openBlock(), _createBlock(RoofsTable, {
          key: 2,
          roofs: _unref(roof_list),
          entity: "coverages",
          onEdit: editRoof,
          onDelete: deleteRoof
        }, null, 8, ["roofs"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})